import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

import { InputTravelReciptRelation } from './InputTravelReciptRelation.entity';

export class InputTravelExpensesReciptRelation<T extends EMode = EMode.entity> {
  /** Alias: add */
  add?: InputTravelReciptRelation<T>[];
  /** Alias: modify */
  modify?: InputTravelReciptRelation<T>[];
  /** Alias: remove */
  remove?: number[];

  __typename?: string;
}

const fields: FieldDefinitions<InputTravelExpensesReciptRelation> = {
  add: {
    alias: 'add',
  },
  modify: {
    alias: 'modify',
  },
  remove: {
    alias: 'remove',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputTravelExpensesReciptRelationEntityDefinition: EntitiyDefinition<InputTravelExpensesReciptRelation> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputTravelExpensesReciptRelation',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
